import { DashboardHelpers } from '@/utils/DashboardHelpers';

import { useDashboardConfig } from '@/hooks/useDashboardConfig';

const MAX_CHARACTER = 30;

interface IHeaderProps {
  isOpen?: boolean;
}

export function SidebarHeader({ isOpen }: IHeaderProps) {
  const config = useDashboardConfig();

  const dashboardName = config.site.name || config.site.shortName;

  return (
    <>
      {isOpen ? (
        <span className="showContent typo-h5-bold text-onColor text-center h-[92px] py-5 px-3">
          {DashboardHelpers.truncateText(dashboardName, MAX_CHARACTER)}
        </span>
      ) : (
        <div className="flex items-center justify-center rounded-full h-[36px] w-[36px] mx-auto mt-5 my-8 bg-secondary text-icon-primary">
          <span className="typo-h5-bold">{DashboardHelpers.getFirstCapitalLetter(dashboardName, 1)}</span>
        </div>
      )}
    </>
  );
}
